import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import store from "@/store";

// Layouts
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import GuestLayout from "@/layouts/GuestLayout.vue";
import ErrorLayout from "@/layouts/ErrorLayout.vue";

// Views
import Login from "@/views/auth/Login.vue";
import ForgotPassword from "@/views/auth/ForgotPassword.vue";
import Index from "@/views/index.vue";
import NotFound from "@/views/NotFound.vue";

// Users
import UserTableView from "@/views/users/UserTableView.vue";
import UserDetailsView from "@/views/users/UserDetailsView.vue";

// Catalog
import CatalogList from "@/views/catalogs/CatalogList.vue";

// Prices
import Prices from "@/views/prices/Prices.vue";

// Offices
import OfficesList from "@/views/offices/OfficesList.vue";

// Clients
import ClientsTable from "@/views/clients/ClientsTable.vue";
import ClientDetails from "@/views/clients/ClientDetails.vue";
import ClientConsultation from "@/views/clients/ClientConsultation.vue";

// Validations
import ValidationTable from "@/views/validations/ValidationTable.vue";
import ChangePassword from "@/views/auth/ChangePassword.vue";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/inicio-de-sesion',
        component: Login,
        name: 'Login',
        meta: {
            requiresAuth: false,
            title: 'Inicio de sesión | DIETEC SDR',
            layout: GuestLayout,
        },
    },
    {
        path: '*',
        component: NotFound,
        name: 'NotFound',
        meta: {
            requiresAuth: false,
            title: 'Página no encontrada | DIETEC SDR',
            layout: ErrorLayout,
        },
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
        name: 'ForgotPassword',
        meta: {
            requiresAuth: false,
            title: 'Recuperar contraseña | DIETEC SDR',
            layout: GuestLayout,
        },
    },
    {
        path: '/change-password',
        component: ChangePassword,
        name: 'ChangePassword',
        meta: {
            requiresAuth: false,
            title: 'Cambiar contraseña | DIETEC SDR',
            layout: GuestLayout,
        }
    },
    {
        path: '/',
        component: Index,
        name: 'Home',
        meta: {
            requiresAuth: true,
            title: 'Inicio | DIETEC SDR',
            layout: DefaultLayout,
        },
    },
    {
        path: '/usuarios',
        component: UserTableView,
        meta: {
            requiresAuth: true,
            allowedRoles: ['ADMIN', 'SUPERADMIN'],
            title: 'Usuarios | DIETEC SDR',
            import: DefaultLayout,
        },
    },
    {
        path: '/usuarios/:username',
        component: UserDetailsView,
        meta: {
            requiresAuth: true,
            allowedRoles: ['ADMIN', 'SUPERADMIN'],
            title: 'Detalles de usuario | DIETEC SDR',
        },
    },
    {
        path: '/catalogos/:catalogType',
        component: CatalogList,
        meta: {
            requiresAuth: true,
            allowedRoles: ['ADMIN', 'SUPERADMIN', 'DIETICIAN'],
            layout: DefaultLayout,
        },
    },
    {
        path: '/precios',
        component: Prices,
        meta: {
            requiresAuth: true,
            allowedRoles: ['SUPERADMIN'],
            layout: DefaultLayout,
            title: 'Precios | DIETEC SDR',
        },
    },
    {
        path: '/consultorios',
        component: OfficesList,
        meta: {
            requiresAuth: true,
            allowedRoles: ['ADMIN', 'SUPERADMIN'],
            layout: DefaultLayout,
            title: 'Consultorios | DIETEC SDR',
        },
    },
    {
        path: '/expedientes',
        component: ClientsTable,
        name: 'ClientsTable',
        meta: {
            requiresAuth: true,
            allowedRoles: ['ADMIN', 'SUPERADMIN', 'DIETICIAN'],
            layout: DefaultLayout,
            title: 'Expedientes | DIETEC SDR',
        }
    },
    {
        path: '/expedientes/:id',
        component: ClientDetails,
        meta: {
            requiresAuth: true,
            allowedRoles: ['ADMIN', 'SUPERADMIN', 'DIETICIAN'],
            layout: DefaultLayout,
            title: 'Detalles del expediente | DIETEC SDR',
        }
    },
    {
        path: '/expedientes/consulta/:id',
        component: ClientConsultation,
        name: 'ClientConsultation',
        meta: {
            requiresAuth: true,
            allowedRoles: ['ADMIN', 'SUPERADMIN', 'DIETICIAN'],
            layout: DefaultLayout,
            title: 'Consulta | DIETEC SDR',
        }
    },
    {
        path: '/validaciones',
        component: ValidationTable,
        meta: {
            requiresAuth: true,
            allowedRoles: ['ADMIN', 'SUPERADMIN'],
            layout: DefaultLayout,
            title: 'Validaciones | DIETEC SDR',
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters['auth/isAuthenticated'];
    const userRole = store.getters['auth/getUser']?.role;

    if (to.meta!.requiresAuth) {
        if (!isAuthenticated) {
            return next('/inicio-de-sesion');
        }

        if (to.meta!.allowedRoles && !to.meta!.allowedRoles.includes(userRole)) {
            return next('/');
        }
    }

    const catalogType = to.params.catalogType;
    if (catalogType) {
        document.title = `${catalogType.charAt(0).toUpperCase() + catalogType.slice(1)} | DIETEC SDR`;
    } else {
        document.title = to.meta!.title || 'DIETEC SDR';
    }

    next();
})

export default router

